import React, { useRef, useEffect } from 'react'
import { Wrapper, Container, Scroll, Page } from './style'
import { WalletHeader } from '@sabavision/dio'
import Sidebar from '../../components/sidebar/Sidebar'
import { Istate } from '../../reducers/types'
import { useSelector } from 'react-redux'

interface ILayout {
  children: React.ReactElement<any, string | React.JSXElementConstructor<any>>
}

function Layout(props: ILayout) {
  const sidebarRef = useRef(null)
  const wallet = useSelector((state: Istate) => state.wallet)
  // @ts-expect-error - Redux state type mismatch with useSelector
  const user = useSelector((state) => state.user)

  const openSidebarDepositMenu = () => {
    // @ts-expect-error Can't correctly type the ref
    if (sidebarRef) sidebarRef?.current?.openDeposit()
  }

  return (
    <Wrapper dir="rtl">
      <Sidebar ref={sidebarRef} />
      <Container>
        <WalletHeader
          value={wallet.advertiser_live_wallet}
          handleAddToWallet={() => {
            openSidebarDepositMenu()
          }}
          disabled={!(user.type === 'advertiser' && user.verification_status === 'verified')}
        />
        <Scroll>
          <Page id="main">{props.children}</Page>
        </Scroll>
      </Container>
    </Wrapper>
  )
}

export default Layout
